import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { UserData, CreateUser, UpdateUser, Pagination, TechnicalAnnouncement } from '@shared/interfaces';
import { map, mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  get(id: number): Observable<UserData>{
    return this.http.get<UserData>(this.api.USER(id));
  }

  create(data: CreateUser): Observable<UserData>{
    return this.http.post<UserData>(this.api.USER(), data);
  }

  edit(id: number, data: UpdateUser): Observable<UserData>{
    return this.http.put<UserData>(this.api.USER(id), data);
  }

  getCurrent(): Observable<UserData>{
    return this.http.get<UserData>(this.api.USER_ME());
  }

  editCurrent(data: UpdateUser): Observable<UserData>{
    return this.http.put<UserData>(this.api.USER_ME(), data);
  }

  getMessages(): Observable<TechnicalAnnouncement[]> {
    return this.http.get<Pagination<TechnicalAnnouncement>>(this.api.TECH_MESSAGES())
      .pipe(map(e => e.items))
  }

  markMessageAsRead(id: number): Observable<boolean> {
    return this.http.post<void>(this.api.TECH_MESSAGE_MARK_AS_READ(id), null)
      .pipe(mapTo(true))
  }

}
